<script setup lang="ts">
import { ActivityModel } from '@/models/activity';

defineProps({
  activity: {
    type: ActivityModel,
    required: true
  }
});
</script>

<template>
    <template v-if="activity.type === 'INVESTIGATION'">
      <template v-if="activity.subType.includes('UPDATE_POST_INVITE')">
        <b>{{ activity.difference.newValues?.email }}</b> to the study
      </template>
      <template v-else-if="activity.subType.includes('UPDATE_API_KEY')">
        study <b>API key</b>
      </template>
      <template v-else-if="activity.subType.includes('JOIN')">
        the study
      </template>
      <template v-else>
        study <b>{{ activity.difference.newValues?.title }}</b>
      </template>
    </template>
    <template v-else-if="activity.type === 'INVESTIGATION_LINK'">
      sharable study link
    </template>
    <template v-else-if="activity.type === 'EXPORT'">
      export for form <b>{{ activity.difference.newValues?.title }}</b>
    </template>
    <template v-else-if="activity.type === 'CASE'">
      case <b>{{ activity.difference.newValues?.label }}</b>
    </template>
    <template v-else-if="activity.type === 'RESPONSE'">
      entry with form <b>{{ activity.difference.newValues?.title }}</b>
    </template>
    <template v-else-if="activity.type === 'SURVEY'">
      form <b>{{ activity.difference.newValues?.title }}</b>
    </template>
    <template v-else-if="activity.type === 'GROUP'">
      <template v-if="activity.subType.includes('GROUP_CREATE') 
        || activity.subType.includes('GROUP_UPDATE') || activity.subType.includes('GROUP_DELETE')">
        group <b>{{ activity.difference.newValues?.name }}</b>
      </template>
    </template>
    <template v-else-if="activity.type === 'FORM_TRANSLATION'">
      form translation for <b>{{ activity.difference.newValues?.title || activity.difference.initialValues?.title }}</b>
    </template>
    <template v-else>
    </template>
</template>

<style scoped lang="scss">
</style>
